import {
  INITIATING_SMALL_TALK_CLIENT_REQUEST, INITIATING_SMALL_TALK_CLIENT_SUCCEDDED, INITIATING_SMALL_TALK_CLIENT_FAILED,
  INITIATE_SMALL_TALK_SESSION, INVALIDATE_SMALL_TALK_SESSION, TOGGLE_SMALL_TALK_WINDOW_VISIBILITY, RECEIVED_SMALL_TALK_MESSAGE,

  SENDING_SMALL_TALK_MESSAGE_REQUEST, SENDING_SMALL_TALK_MESSAGE_SUCCEDDED, SENDING_SMALL_TALK_MESSAGE_FAILED,
  FETCHING_SMALL_TALK_MESSAGES_REQUEST, FETCHING_SMALL_TALK_MESSAGES_SUCCEDDED, FETCHING_SMALL_TALK_MESSAGES_FAILED,
  FETCHING_SMALL_TALK_CONTACT_PRESENCE_REQUEST, FETCHING_SMALL_TALK_CONTACT_PRESENCE_SUCCEDDED, FETCHING_SMALL_TALK_CONTACT_PRESENCE_FAILED,
} from './actionTypes.jsx';

import axios from 'axios';
import _ from 'lodash';

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const SMALL_TALK_BASE_URL = `${apiUrl}/api/2.0/small_talk/users/initiate`;

/*
* Initiate small talk
*/
export function initiateSmallTalkClient(id, request) {
  return function (dispatch) {
    dispatch(initiatingSmallTalkRequest(id));

    return axios({
      method: 'POST',
      url: `${SMALL_TALK_BASE_URL}`
    })
      .then(response => {
        return dispatch(initiatingSmallTalkSuccedded(response.data))
      })
      .catch(error => {
        console.log(error);
        return dispatch(initiatingSmallTalkFailed(error))
      })
  }
}

function initiatingSmallTalkRequest() {
  return {
    type: INITIATING_SMALL_TALK_CLIENT_REQUEST,
    payload: {
    }
  }
}

function initiatingSmallTalkSuccedded(json) {
  return {
    type: INITIATING_SMALL_TALK_CLIENT_SUCCEDDED,
    payload: json
  }
}

function initiatingSmallTalkFailed(id, error) {
  return {
    type: INITIATING_SMALL_TALK_CLIENT_FAILED,
    payload: error
  }
}

export function initiateSmallTalkSession(contact) {
  return {
    type: INITIATE_SMALL_TALK_SESSION,
    payload: contact
  }
}


export function invalidateSmallTalkSession(contact) {
  return {
    type: INVALIDATE_SMALL_TALK_SESSION,
    payload: contact
  }
}

export function toggleSmallTalkWindowVisibility(contact, visible) {
  return {
    type: TOGGLE_SMALL_TALK_WINDOW_VISIBILITY,
    payload: {contact, visible}
  }
}

export function sendMessage(client, message) {
  return function (dispatch) {
    dispatch(sendingMessageRequest(message));

    return client.publish(message).then(response => {
      return dispatch(sendingMessageSuccedded(message));
    }).catch(error => {
      return dispatch(sendingMessageFailed(message, error));
    });
  }
}

function sendingMessageRequest(message) {
  return {
    type: SENDING_SMALL_TALK_MESSAGE_REQUEST,
    payload: message
  }
}

function sendingMessageSuccedded(message) {
  return {
    type: SENDING_SMALL_TALK_MESSAGE_SUCCEDDED,
    payload: {
      message: message
    }
  }
}

function sendingMessageFailed(message, error) {
  return {
    type: SENDING_SMALL_TALK_MESSAGE_FAILED,
    payload: {
      message: message,
      error: error
    }
  }
}


/**
 * Fetch messages
 * 
*/
export function fetchMessages(client, channels, limit) {
  return function (dispatch) {
    dispatch(fetchingMessagesRequest(channels));

    return client.fetchMessages({
      channels: channels,
      count: limit
    })
    .then(response => {
      const messages = _.get(response, `channels['${channels}']`);
      return dispatch(fetchingMessagesSuccedded(channels, messages));
    }).catch(error => {
      console.log(error);
      return dispatch(fetchingMessagesFailed(channels, error));
    });
  }
}

function fetchingMessagesRequest(channel) {
  return {
    type: FETCHING_SMALL_TALK_MESSAGES_REQUEST,
    payload: channel
  }
}

function fetchingMessagesSuccedded(channel, response) {
  return {
    type: FETCHING_SMALL_TALK_MESSAGES_SUCCEDDED,
    payload: {
      channel: channel,
      response: response
    }
  }
}

function fetchingMessagesFailed(channel, error) {
  return {
    type: FETCHING_SMALL_TALK_MESSAGES_FAILED,
    payload: {
      channel: channel,
      error: error
    }
  }
}

export function triggerMessageRecevied(channel, message){
  return {
    type: RECEIVED_SMALL_TALK_MESSAGE,
    payload: {
      channel: channel,
      message: message
    }
  } 
}

/**
 * Fetch contact presence
 * 
*/
export function fetchPresenceForContacts(client, uuid, contacts) {
  return function (dispatch) {
    dispatch(fetchingPresenceForContactsRequest(uuid, contacts));

    const channels = contacts.map(id => {
      return `${uuid}.c_${id}`;
    });

    client.hereNow({
      channels: channels,
      includeUUIDs: true,
      includeState: true
    }).then((response) => {
      const result = {};
      contacts.forEach(contact => {
        const channelName = `${uuid}.c_${contact}`;
        const available = _.get(response, `channels['${channelName}'].occupants.0.uuid`) != null;

        result[contact] = available;        
      })

      dispatch(fetchingPresenceForContactsSuccedded(uuid, contacts, result));
    }).catch((error) => {
      console.log(error)
      dispatch(fetchingPresenceForContactsFailed(uuid, contacts, error));
    });
  }
}

function fetchingPresenceForContactsRequest(uuid, contacts) {
  return {
    type: FETCHING_SMALL_TALK_CONTACT_PRESENCE_REQUEST,
    payload: {
      uuid, contacts
    }
  }
}

function fetchingPresenceForContactsSuccedded(uuid, contacts, response) {
  return {
    type: FETCHING_SMALL_TALK_CONTACT_PRESENCE_SUCCEDDED,
    payload: {
      uuid: uuid,
      contacts: contacts,
      response: response
    }
  }
}

function fetchingPresenceForContactsFailed(uuid, contacts, error) {
  return {
    type: FETCHING_SMALL_TALK_CONTACT_PRESENCE_FAILED,
    payload: {
      uuid: uuid,
      contacts: contacts,
      error: error
    }
  }
}

export function togglePresenceForContact(contact, available){
  return {
    type: FETCHING_SMALL_TALK_CONTACT_PRESENCE_SUCCEDDED,
    payload: {
      uuid: null,
      contacts: [contact],
      response: {
        [contact]: available
      }
    }
  }
}
